import Footer from '@/components/structure/Footer';
import TopNavigation from '@/components/structure/navigation/TopNavigation';

export default [
    {
        path: '/style',
        name: 'style-guide',
        components: {
            default: () => import(/* webpackChunkName: "style" */ '@/views/StyleGuide'),
            footer: Footer,
            topNavigation: TopNavigation,
        },
    },
];
